/* istanbul ignore file */

export default {
  businessRegistrationCountry: {
    type: 'string',
    required: {
      value: true,
      when: {
        _or_: [
          {
            $contractType: {
              eq: 'B2B',
            },
          },
          {
            $contractType: {
              eq: 'CFS',
            },
            $contractingPartyForm: {
              in: ['SELF_EMPLOYED', 'SOLE_PROPRIETOR', 'LEGAL_ENTITY'],
            },
          },
        ],
      },
    },
  },
  contractingPartyForm: {
    type: 'enum',
    required: {
      value: true,
      when: {
        $contractType: {
          eq: 'CFS',
        },
      },
    },
  },
  officeId: {
    type: 'enum',
    required: true,
  },
  number: {
    type: 'string',
    maxSize: 64,
    required: {
      value: true,
      when: {
        $officeId: {
          nin: ['3', 3],
        },
      },
    },
  },
  dateOfSignature: {
    type: 'date',
    maxDate: '$startDate',
    required: true,
  },
  contractPosition: {
    type: 'enum',
    required: true,
  },
  contractType: {
    type: 'enum',
    required: true,
  },
  startDate: {
    type: 'date',
    minDate: '$dateOfSignature',
    required: true,
  },
  endDate: {
    type: 'date',
    required: {
      value: true,
      when: [
        {
          $isIndefinite: {
            eq: false,
          },
        },
      ],
    },
    minDate: '$startDate',
  },
  paidLeaveBalance: {
    type: [
      {
        value: 'enum',
        when: {
          $contractType: {
            eq: 'EC',
          },
        },
      },
    ],
    minValue: 0,
    maxValue: 26,
    required: {
      value: true,
      when: [
        {
          $contractType: {
            eq: 'EC',
          },
          $officeId: {
            in: ['3', 3],
          },
        },
      ],
    },
  },
  extendedPaidLeaveBalanceApplyDate: {
    type: 'date',
    minDate: '$startDate',
    maxDate: '$endDate',
    required: {
      value: true,
      when: {
        $contractType: {
          eq: 'EC',
        },
        $officeId: {
          in: ['3', 3],
        },
        $paidLeaveBalance: {
          gt: 20,
        },
      },
    },
  },
  previousPaidLeaveBalance: {
    type: 'int',
    minValue: 0,
    maxValue: 26,
  },
  assignmentType: {
    type: 'enum',
    required: true,
  },
  workRate: {
    type: 'number',
    minValue: 1,
    maxValue: 100,
    required: {
      value: true,
      when: {
        $assignmentType: {
          eq: 'PART_TIME',
        },
      },
    },
  },
  scanIds: {
    type: 'array',
    maxSize: 10,
  },
  hasProbationPeriod: {
    type: 'boolean',
    required: {
      value: true,
      when: [
        {
          $contractType: {
            ne: 'INTERNSHIP',
          },
        },
        {
          $contractType: {
            ne: 'CFS',
          },
        },
      ],
    },
  },
  probationPeriodEndedAt: {
    type: 'date',
    minDate: '$startDate',
  },
  comment: {
    required: {
      value: true,
      when: {
        $ignoreNotStrictRules: {
          eq: true,
        },
      },
    },
  },
};
